// extracted by mini-css-extract-plugin
module.exports = {"container":"InvestorEventDetail_container__2xch0","article":"InvestorEventDetail_article__1NTvm"};